module.exports = __webpack_public_path__ + "img/10-mob.d5fae80b.svg";